import { useJusticeCaseTypeStore } from '../dictionary/justiceCaseTypeStore';
import { useJusticeCaseStore } from '../dictionary/justiceCaseStore';
import { useJusticeDecisionGroupStore } from '../dictionary/justiceDecisionGroupStore';
import { useAccountingObjectStore } from '../dictionary/accountingObjectStore';
import { useAssetStore } from '../dictionary/assetStore';
import { useAssetCategoryStore } from '../dictionary/assetCategoryStore';
import { useReceiptStore } from '../dictionary/receiptStore';
import { useAccountCategoryStore } from '../dictionary/accountCategoryStore';
import { useAccountStore } from '@/stores/dictionary/accountStore';
import { useCurrencyStore } from '@/stores/dictionary/currencyStore';
import { useStockStore } from '@/stores/dictionary/stockStore';
import { useBankInfoStore } from '@/stores/dictionary/bankInfoStore';
import { useBankStandardStore } from '@/stores/dictionary/bankStandardStore';
import { useDefaultAccountStore } from '@/stores/dictionary/defaultAccountStore';
import { useListCodeStore } from '../dictionary/listCodeStore';
import { useBranchStore } from '../dictionary/branchStore';
import { useJusticeDecisionStore } from '../dictionary/justiceDecisionStore';
import { useAreaStore } from '../dictionary/areaStore';
import {
  ModuleAccountCategory,
  ModuleReceipt,
  ModuleAccount,
  ModuleCurrency,
  ModuleStock,
  ModuleBankInfo,
  ModuleBankStandard,
  ModuleJusticeCaseType,
  ModuleJusticeCase,
  ModuleJusticeDecisionGroup,
  ModuleListCode,
  ModuleBranch,
  ModuleDefaultAccount,
  ModuleAccountingObject
} from '@/stores/moduleConst';
import { ModuleArea } from '../moduleConst';

export const useWebSocketFactoryCacheStore = () => {
  /**
   * Lấy store theo từng nghiệp vụ
   * HQMINH 14.04.2023
   * @param {*} module
   * @returns
   */
  const factoryCacheStore = module => {
    switch (module) {
      case ModuleJusticeCaseType:
        return useJusticeCaseTypeStore();
      case ModuleJusticeCase:
        return useJusticeCaseStore();
      case ModuleJusticeDecisionGroup:
        return useJusticeDecisionGroupStore();
      case ModuleAccount:
        return useAccountStore();
      case ModuleCurrency:
        return useCurrencyStore();
      case ModuleStock:
        return useStockStore();
      case ModuleBankInfo:
        return useBankInfoStore();
      case ModuleBankStandard:
        return useBankStandardStore();
      case ModuleAccountingObject:
        return useAccountingObjectStore();
      case ModuleAccountCategory:
        return useAccountCategoryStore();
      case ModuleReceipt:
        return useReceiptStore();
      case ModuleAccount:
        return useAccountStore();
      case ModuleListCode:
        return useListCodeStore();
      case ModuleBranch:
        return useBranchStore();
      case ModuleDefaultAccount:
        return useDefaultAccountStore();
      case ModuleArea:
        return useAreaStore();
      default:
        break;
    }
  };

  return {
    factoryCacheStore,
  };
};
